import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Center } from '../../parts/bases/Center'
import { Fixed } from '../../parts/bases/Fixed'
import { Text } from '../../parts/bases/Text'
import { VStack } from '../../parts/bases/VStack'
import { PinkNeonButton } from '../../parts/buttons/PinkNeonButton'
import { Policy } from './Policy'

export type Props = {
  visible: boolean
  onClickAgree: () => void
  children: ReactNode
}

export const Layout = (props: Props) => {
  const { t } = useTranslation()
  return (
    <>
      {props.visible ? (
        <Fixed className="z-50 h-screen w-full items-center justify-center bg-black bg-opacity-50 px-5">
          <VStack className="h-[80%] w-full max-w-[800px] rounded-xl border-2 border-[#00FBEC] bg-black">
            <VStack className="hidden-scrollbar w-full flex-1 overflow-scroll p-6">
              <Text className="mt-6 text-sm leading-6 text-white">
                <Policy />
              </Text>
            </VStack>
            <Center className="py-7">
              <PinkNeonButton onClick={props.onClickAgree}>
                <Text className="font-bold text-white">{t('Agreement.Submit')}</Text>
              </PinkNeonButton>
            </Center>
          </VStack>
        </Fixed>
      ) : null}
      {props.children}
    </>
  )
}
